import { render, staticRenderFns } from "./ResultAgreement.vue?vue&type=template&id=640cb79e&"
import script from "./ResultAgreement.vue?vue&type=script&lang=js&"
export * from "./ResultAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ResultAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports